// File: src/services/transactions/expenseByCategoryForPeriod.ts

import { fetchExpensesByCategoryForPeriodAPI } from "../../../infrastructure/api/transactions";

export interface ExpenseData {
  category: string;
  amount: number;
}

export const fetchExpensesByCategoryForPeriod = async (
  period: string,
  accessToken: string,
): Promise<ExpenseData[]> => {
  try {
    const expenseData = await fetchExpensesByCategoryForPeriodAPI(
      period,
      accessToken,
    );

    console.log("expenseData: ", expenseData);

    return expenseData;
  } catch (error) {
    console.error("Error fetching expense data by category:", error);
    throw error;
  }
};
